import axios from './axios';
import { Project, ProjectWithCount } from '../types/project';
import { Issue } from '../types/issue';

const BASE_URL = '/public';

interface GetIssuesParams {
  project_id?: number;
  skip?: number;
  limit?: number;
}

export const publicApi = {
  getProject: async (id: number) => {
    const response = await axios.get<ProjectWithCount>(`${BASE_URL}/projects/${id}`);
    return response.data;
  },

  getIssues: async (params: GetIssuesParams) => {
    const response = await axios.get<Issue[]>(`${BASE_URL}/issues/`, { params });
    return response.data;
  },
};
